<template>
  <div class="form-group">
    <label :for="id" class="form-label">{{ label }}</label>
    <div class="d-flex align-items-center gap-2">
      <button
          v-if="iconButton"
          type="button"
          class="btn btn-sm btn-secondary"
          @click="handleIconAction"
      >
        <i :class="iconClass"></i>
      </button>
      <select
          v-model="selectedValue"
          :id="id"
          class="form-select flex-fill"
          :required="required"
          :disabled="disabled"
          :class="customClass"
      >
        <option value="" disabled>{{ placeholder }}</option>
        <option
            v-for="option in options"
            :key="getKey(option)"
            :value="getKey(option)"
            :disabled="isDisabled(option)"
        >
          {{ option.name }} <span v-if="formatOption(option)">({{ formatOption(option) }})</span>
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modelValue: [String, Number], // Permite binding con valores string o numéricos
    options: {
      type: Array,
      required: true
    },
    id: {
      type: String,
      default: "type_id"
    },
    label: {
      type: String,
      default: "Select Type"
    },
    placeholder: {
      type: String,
      default: "Choose an option"
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: "" // Permite pasar clases personalizadas
    },
    errorMessage: {
      type: String,
      default: "" // Mensaje de error opcional
    },
    formatFunction: {
      type: Function,
      default: null // Permite pasar una función opcional para formatear la opción
    },
    iconButton: {
      type: Boolean,
      default: false // Si es true, se muestra el botón
    },
    iconClass: {
      type: String,
      default: "fa-solid fa-plus" // Ícono que se quiere mostrar
    },
    iconAction: {
      type: [String, Function],
      default: null // Ruta a navegar o función a ejecutar
    },
    openInNewTab: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selectedValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    },

  },
  methods: {
    getKey(option) {
      return option.value !== undefined ? option.value : option.id;
    },
    formatOption(option) {
      return this.formatFunction ? this.formatFunction(option) : null;
    },
    handleIconAction() {
      if (typeof this.iconAction === "function") {
        this.iconAction();
      } else if (typeof this.iconAction === "string") {
        if (this.openInNewTab) {
          window.open(this.iconAction, '_blank');
        } else {
          this.$router.push(this.iconAction);
        }
      }
    },
    isDisabled(option){
      return option.name === 'Mixed' || option.name === 'OnLine'|| option.name === 'Team'
    }
  }

};
</script>
